import type { PinOnImageResultT } from '@mentimeter/visualizations';
import type { PinOnImageResult } from '@core-api/presentation/types/response';

export const convertPinOnImageResults = (
  results: PinOnImageResultT[],
): PinOnImageResult[] => {
  return results.map((result) => ({
    x: result.percentage_x,
    y: result.percentage_y,
    responseCount: result.number_of_pins,
    correctAnswerStatus: result.is_correct ? 'correct' : 'incorrect',
  }));
};
